// extracted by mini-css-extract-plugin
module.exports = {"icon":"I51woZtgr3eRQFtjx4mxe"};